import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { EmailLogResponse, SendEmailInput, EmailLog } from '@peles/shared';
import * as emailsApi from '../api/emails';

export function useEmailLogs(filters?: {
  status?: string;
  template?: string;
  to?: string;
  limit?: number;
  offset?: number;
}) {
  return useQuery<EmailLogResponse>({
    queryKey: ['email-logs', filters],
    queryFn: () => emailsApi.getEmailLogs(filters),
  });
}

export function useSendEmail() {
  const queryClient = useQueryClient();

  return useMutation<EmailLog, Error, SendEmailInput>({
    mutationFn: (input) => emailsApi.sendEmail(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['email-logs'] });
    },
  });
}
